module.exports = __webpack_public_path__ + "static/img/p9.7f23fa1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner/p9.png
// module id = 7YiS
// module chunks = 0